import { render, staticRenderFns } from "./RoomScordList.vue?vue&type=template&id=4617794a&scoped=true&"
import script from "./RoomScordList.vue?vue&type=script&lang=js&"
export * from "./RoomScordList.vue?vue&type=script&lang=js&"
import style0 from "./RoomScordList.vue?vue&type=style&index=0&id=4617794a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4617794a",
  null
  
)

export default component.exports